import { withRouter } from 'react-router'
import AccountVip from '../../components/AccountVip/AccountVip'
import { connect } from 'react-redux'
import { compose } from 'react-apollo'

export default compose()(withRouter(
    connect(
        null,
        null
    )(AccountVip)
))


// WEBPACK FOOTER //
// ./src/containers/AccountVip/AccountVip.js